import { defineComponent, nextTick } from "vue";
import axios from 'axios'

import { VForm } from "vuetify/components";

export default defineComponent({
    components: {
    },
    data() {
        return {
            error: null,
            loading: false,
            valid: true
        }
    },
    computed: {
        formRef(): VForm {
            return this.$refs.formRef
        }
    },
    methods: {
        async onSubmit() {
            const { valid } = await this.formRef.validate()
            if (!valid) {
                await nextTick()
                const firstErrorElement = document.querySelector(
                    '.v-input--error, .v-select--error, .v-file-input--error, .v-textarea--error'
                ) as HTMLElement | null

                if (firstErrorElement) {
                    firstErrorElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center', // "center" is nicest on mobile & desktop
                    })

                    const input = firstErrorElement.querySelector('input, textarea, select')
                        ; (input as HTMLElement | null)?.focus()
                }
                return;
            }

            await this.submit(this.store)
        },
        async submitHook(fd:FormData) {
        },
        async submit(store) {
            let form = store.toJSON();
            this.loading = true;
            try {
                this.error = null;
                let fd = new FormData();
                fd.append('form', JSON.stringify(form));
                // opportunity for subclass to add file data
                await this.submitHook(fd);
                let result = await axios.post(`/forms/uniform/${store.id}/submit`, fd)
                if (result?.data?.success == false) {
                    this.error = result.data.error;
                }
                else {
                    await store.removeBackups();
                    window.location.href = `/forms/uniform/${store.id}/success`;
                }
            }
            catch (err) {
                this.error = typeof err == 'string' ? err : err.toString();
            }
            finally {
                this.loading = false;
            }
        }
    }
})
